import './ItauBusinessBanner.scss'
import Text from 'components/Text'
import IconCarteirada from '../../../static/iconCarteirada.svg'

const ItauBusinessBanner = () => {
  return (
    <div className="itau-business-banner">
      <div className="icon">
        <IconCarteirada aria-hidden="true" alt="" />
      </div>
      <div className="inline">
        <Text p className="inline-title">
          Sua dívidas estão sob gestão da Recovery
        </Text>
        <Text p>
          Recovery é uma empresa Itaú e nossa missão é ser seu aliado contra as
          dívidas
        </Text>
      </div>
    </div>
  )
}

export default ItauBusinessBanner
